import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableShows from "./TableShows";
import { toast } from "react-toastify";
import useAuth from "../../../hooks/useAuth";

export default function Shows() {
  const { auth } = useAuth();
  const token = auth?.access_token;

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingError, setLoadingError] = useState(null);
  const rowsPerPage = 10;

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  // helper to format date/time
  const formatShowDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    // Use ru‑RU locale (matches the rest of the UI)
    return date.toLocaleDateString("ru-RU", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatShowTime = (isoString) => {
    if (!isoString) return "";
    // The server sends "0000-01-01T00:15:00Z" – extract only the time
    const timePart = isoString.split("T")[1]; // e.g. "00:15:00Z"
    const [hours, minutes] = timePart.split(":");
    // Build a Date object with any date, just to format the time
    const date = new Date(2020, 0, 1, hours, minutes);
    return date.toLocaleTimeString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    const fetchShowCase = async () => {
      setLoadingData(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/show_case/list?page=${page + 1}&limit=${rowsPerPage}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (!response.ok) {
          const errorMessage = "Ошибка при загрузке данных";
          toast.error(errorMessage);
          setLoadingData(false);
          setLoadingError(errorMessage);
          return;
        }
        const result = await response.json();
        const rawData = result?.data || [];
        const formattedData = rawData.map((item) => ({
          ...item,
          show_date: formatShowDate(item.show_date),
          show_time: formatShowTime(item.show_time),
        }));
        setData(formattedData);
        setTotal(result?.total || 0);
      } catch (error) {
        setLoadingError(`Ошибка: ${error.message}`);
      } finally {
        setLoadingData(false);
      }
    };

    fetchShowCase();
  }, [token, page, rowsPerPage]);

  if (loadingData) {
    return (
      <div className="loadingContainer">
        <div className="loader"></div>
      </div>
    );
  }
  if (loadingError) {
    return (
      <div className="errorDataBox">
        <p>{loadingError}</p>
      </div>
    );
  }
  return (
    <div className="container">
      <h1 className="title" style={{ marginBottom: 20 }}>
        Показы
      </h1>

      <TableShows
        shows={data}
        page={page}
        total={total}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
      />
    </div>
  );
}
